import React from "react";
import CollabHome from "../shared/components/CollabHome";
import ExperiencesHome from "../shared/components/ExperiencesHome";
import FormulesHome from "../shared/components/FormulesHome";
import HeaderHome from "../shared/components/HeaderHome";
import ProjectsHome from "../shared/components/ProjectsHome";
import TransitionPage from "../shared/components/animations/TransitionPage";
import CardFooter from "../shared/components/CardFooter";
import Navbar from "../shared/layout/Navbar";
import Footer from "../shared/layout/Footer";

const Home = () => {
  return (
    <>
      <TransitionPage />
      <Navbar />
      <HeaderHome />
      <ProjectsHome />
      <FormulesHome />
      <ExperiencesHome />
      <CollabHome />
      <CardFooter />
      <Footer />
    </>
  );
};

export default Home;
